var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/1_b.svg"),"alt":"Transportir","width":"auto","height":"56"}})
}
var staticRenderFns = []

export { render, staticRenderFns }